import React, { Component } from 'react';
//import Config from './Config';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/ColumnSelector.css';
//import FX from './functions/functions';
class ColumnSelector extends Component {
  constructor(props){
    super(props);
    this.state = {show:false};
  }
  toggle = () => {
    this.setState({show:!this.state.show});
  }
  hide = () => {
    this.setState({show:false});
  }
  toggleColumn = col => {
    var cols = this.props.list.state.columns;
    cols.forEach((_col,i) => {
      if(_col.field === col.field){
        cols[i].show = !_col.show;
      }
    })
    this.props.list.setState({columns:cols});
  }
  render() {
    var vis = 'ColumnSelector';
    if(this.state.show){
      vis = 'ColumnSelector show';
    }
    var items = this.props.list.state.columns.map((col,i) => {
      var className = col.show ? 'visible' : '';
      return <li key={i}><a className={className} onClick={this.toggleColumn.bind(this, col)}>{col.title}</a></li>;    
    });
    return (
      <div className={vis}>
        <div className="btnLand" onClick={this.toggle}>Choose Columns</div>
        <ul className="ColumnList" id="ColumnList">
          {items}
          <li className="hide" onClick={this.hide}>Hide</li>
        </ul>
      </div>
    );
  }
}

export default ColumnSelector;



// WEBPACK FOOTER //
// ./src/ColumnSelector.js